<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="message-card">
				<div class="header">
					<div class="tabbar">
						<div class="item" @click="textClick(index)" :class="{ active: count == index }" v-for="(item, index) in newContenList">
							<div class="txt">{{ item }}</div>
							<div class="line"></div>
						</div>
					</div>
					<div class="more" @click="moreClick()">查看更多></div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in textList" @click="contentClick(item.id)">
						<div class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
						<div class="date" v-if="item.createTime">更新日期 {{ item.createTime.slice(0, 10) }}</div>
					</div>
				</div>
			</div>
			<div class="project-list">
				<div class="header">
					<div class="item active">
						<div class="txt">工程项目</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="list-wrapper" v-for="(classificationItem, classificationIndex) in engineeringListClassification" :key="classificationIndex">
					<div class="title">{{ classificationItem.title }}</div>
					<div class="list">
						<a :href="item.contentUrl" class="item" v-for="(item, index) in classificationItem.list">
							<img :src="webImg + item.contentImg + imgCut(345, 242)" alt="" @dragstart.prevent />
							<div>{{ item.contentTitle }}</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="home">
				<div class="content">
					<div class="left" style="width: 650px">
						<el-carousel trigger="click" height="386px" indicator-position="none">
							<el-carousel-item v-for="(item, index) in textImgList" :key="index">
								<div style="position: relative; cursor: pointer">
									<img
										:src="webImg + item.contentImg + imgCut(650, 356)"
										alt=""
										srcset=""
										@dragstart.prevent
										style="width: 650px;!important; height: 386px;"
										@click="contentClick(item.id)"
									/>
									<div class="leftText">
										<div>{{ filterUnit(item.contentTitle) }}</div>
									</div>
								</div>

								<!-- <div class="leftText">1111</div> -->
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="right">
						<div class="newContent">
							<div class="text">
								<div class="textItem" @click="textClick(index)" :class="{ textItem1: count == index }" v-for="(item, index) in newContenList">{{ item }}</div>
							</div>

							<div class="more" @click="moreClick()">更多 >></div>
						</div>

						<div class="newMain">
							<div class="newMainItem" v-for="(item, index) in textList" @click="contentClick(item.id)">
								<div class="newMainDescription">{{ filterUnit(item.contentTitle) }}</div>
								<div class="time" v-if="item.createTime">[{{ item.createTime.slice(0, 10) }}]</div>
							</div>
						</div>
					</div>
				</div>

				<div class="engineering">
					<div class="engineeringName">
						<div>业务领域</div>
						<div class="line"></div>
					</div>
					<div class="engineeringMain-wrapper" v-for="(classificationItem, classificationIndex) in engineeringListClassification" :key="classificationIndex">
						<div class="title">{{ classificationItem.title }}</div>
						<div class="engineeringMain">
							<a :href="item.contentUrl" class="engineeringMainItem" v-for="(item, index) in classificationItem.list">
								<img :src="webImg + item.contentImg + imgCut(310, 225)" alt="" @dragstart.prevent />
								<div>{{ filterUnit(item.contentTitle) }}</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { contentPage, businessList } from '../api/api';
export default {
	name: 'homeTemplate',
	data() {
		return {
			newsList: [],
			textImgList: [],
			newContenList: ['新闻动态', '通知公告'],
			count: 0,
			textList: [],
			engineeringList: [],
			engineeringListClassification: [
				{
					title: '环保工程',
					list: []
				},
				{
					title: '城市基础设施工程',
					list: []
				},
				{
					title: '能源工程',
					list: []
				},
				{
					title: '新型工业化建设及其他',
					list: []
				}
			]
		};
	},
	created() {
		this.getContentPage(2142); //工程项目
		this.getNewsPage(2143); //新闻动态
		this.getNewImgPage(2143); //新闻动态
	},
	methods: {
		filterUnit(item) {
			return item.replace(/<br>/g, '');
		},

		newsImgClick() {
			console.log(1111111);
		},
		//
		textClick(index) {
			this.count = index;
			if (index == 0) {
				this.getNewsPage(2143); //新闻动态
			} else {
				this.getNewsPage(2128); //通知公告
			}
		},
		//新闻动态
		contentClick(id) {
			if (this.count == 0) {
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 0,
						contentId: id
					}
				});
			} else {
				console.log(this.count, 'this.count');
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 1,
						contentId: id
					}
				});
			}
		},
		moreClick(id) {
			if (this.count == 0) {
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 0
					}
				});
			} else {
				console.log(this.count, 'this.count');
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 1
					}
				});
			}
		},
		getContentPage(id) {
			contentPage(1, 1000, id).then((res) => {
				this.engineeringList = res.data;
				// console.log('this.engineeringList: ', this.engineeringList);
				for (let i = 0; i < this.engineeringList.length; i++) {
					if (
						this.engineeringList[i].contentTitle == '市政污水' ||
						this.engineeringList[i].contentTitle == '农村污水' ||
						this.engineeringList[i].contentTitle == '工业废水' ||
						this.engineeringList[i].contentTitle == '污泥处置' ||
						this.engineeringList[i].contentTitle == '水体治理' ||
						this.engineeringList[i].contentTitle == '洒水除尘' ||
						this.engineeringList[i].contentTitle == '固体废弃物'
					) {
						this.engineeringListClassification[0].list.push(this.engineeringList[i]);
					}
					if (
						this.engineeringList[i].contentTitle == '城市供水' ||
						this.engineeringList[i].contentTitle == '轨道交通' ||
						this.engineeringList[i].contentTitle == '机场安检' ||
						this.engineeringList[i].contentTitle == '城市供热' ||
						this.engineeringList[i].contentTitle == '暖通工程' ||
						this.engineeringList[i].contentTitle == '智慧城市'
					) {
						this.engineeringListClassification[1].list.push(this.engineeringList[i]);
					}
					if (
						this.engineeringList[i].contentTitle == '电厂电站设备' ||
						this.engineeringList[i].contentTitle == '核电站气体存贮' ||
						this.engineeringList[i].contentTitle == '清洁能源' ||
						this.engineeringList[i].contentTitle == '新能源' ||
						this.engineeringList[i].contentTitle == '节能管理'
					) {
						this.engineeringListClassification[2].list.push(this.engineeringList[i]);
					}
					if (
						this.engineeringList[i].contentTitle == '工业工程' || 
						this.engineeringList[i].contentTitle == '其他工程' || 
						this.engineeringList[i].contentTitle == '数智工厂' || 
						this.engineeringList[i].contentTitle == '零碳园区' || 
						this.engineeringList[i].contentTitle == '数据中心' || 
						this.engineeringList[i].contentTitle == '石油化工' || 
						this.engineeringList[i].contentTitle == '医疗器械' || 
						this.engineeringList[i].contentTitle == '智慧农业'
						) {
						this.engineeringListClassification[3].list.push(this.engineeringList[i]);
					}
				}
			});
		},

		getNewsPage(id) {
			contentPage(1, 9, id, '', 1).then((res) => {
				this.textList = res.data;
			});
		},
		getNewImgPage(id) {
			contentPage(1, 5, id, '', 1, '', 1).then((res) => {
				this.textImgList = res.data.filter((item) => item.contentImg);
			});
		},
		getImg(list) {
			if (list && list.length > 0) {
				let arrList = [];
				list.forEach((item, index) => {
					if (item.contentImg) {
						arrList.push(item);
					}
				});
				return arrList;
			} else {
				return [];
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.device-mobile {
	.message-card {
		width: 9.466667rem;

		.header {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tabbar {
				display: flex;
				align-items: center;

				.item {
					position: relative;
					display: flex;
					flex-direction: column;
					margin-right: 0.4rem;

					&.active {
						.txt {
							font-size: 0.453333rem;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: bold;
							color: #000000;
						}

						.line {
							display: block;
						}
					}

					.txt {
						font-size: 0.4rem;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #000000;
					}

					.line {
						position: absolute;
						bottom: -0.266667rem;
						display: none;
						margin-top: 0.213333rem;
						width: 1.2rem;
						height: 0.053333rem;
						background: #007cc3;
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
					}
				}
			}

			.more {
				font-size: 0.346667rem;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #007cc3;
			}
		}

		.list {
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.item {
				width: 100%;
				box-sizing: border-box;
				padding: 0.4rem;
				border-bottom: 0.026667rem solid #eeeeee;

				.title {
					font-size: 0.4rem;
					// font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					line-height: 0.533333rem;
				}

				.date {
					margin-top: 0.266667rem;
					font-size: 0.266667rem;
					// font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
		}
	}

	.project-list {
		width: 9.466667rem;

		.header {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.4rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007cc3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.list-wrapper {
			display: flex;
			flex-direction: column;
			.title {
				font-size: 0.4rem;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: bold;
				color: #000000;
				margin-bottom: 0.4rem;
			}
			.list {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.item {
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-bottom: 0.266667rem;
					text-decoration: none;

					img {
						width: 4.6rem;
						height: 3.226667rem;
					}

					div {
						margin: 0.266667rem 0;
						font-size: 0.346667rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #004ea1;
					}
				}
			}
		}
	}
}

.device-pc {
	.home {
		margin-top: 80px;
	}

	.left {
		overflow: hidden;

		.leftText {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 40px;

			div {
				width: 500px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
				text-align: center;
				// display: flex;
				// justify-content: center;
				// align-items: center;
			}

			font-size: 16px;
			font-weight: normal;
			color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			background: rgba(0, 0, 0, 0.4);
		}
	}

	.content {
		width: 1300px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		padding-bottom: 20px;
		// justify-content: center;
	}

	.right {
		width: 650px;
		height: 386px;
		// height: 485px;
		// box-shadow: -5px 4px 5px 0px rgba(153, 153, 153, 1);
		box-sizing: border-box;
		border: 1px solid #e6e3e3;
		border-left: none;
		box-sizing: border-box;

		.newContent {
			height: 49px;
			border-bottom: 1px solid #e6e3e3;
			display: flex;
			align-items: center;
			padding: 0 20px;
			box-sizing: border-box;
		}

		.text {
			display: flex;
			align-items: center;

			.textItem {
				font-size: 20px;
				// font-family: PingFang SC-Semibold, PingFang SC;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: 600;
				color: #333333;
				cursor: pointer;
			}

			.textItem:first-child {
				margin-right: 48px;
			}

			.textItem1 {
				font-size: 20px;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #0175c2;
			}
		}

		.more {
			font-size: 14px;
			font-family: PingFang SC-Semibold, PingFang SC;
			font-weight: 600;
			color: #b6b6b6;
			margin-left: auto;
			margin-top: 5px;
		}

		.newMain {
			padding: 0 20px;
			box-sizing: border-box;

			.newMainItem {
				height: 36px;
				color: #333333;
				width: 700px;
				// text-indent: 20px;
				display: block;
				line-height: 36px;
				font-size: 17px;

				display: flex;
				align-items: center;
				cursor: pointer;

				.newMainDescription {
					width: 500px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.time {
					// font-size: 13px;
					// font-family: PingFang SC-Semibold, PingFang SC;
					// font-weight: 600;
					// color: #000000;
					margin-left: 20px;
				}
			}
		}
	}

	.engineering {
		width: 1920px;
		// height: 1393px;
		background: #f5f5f5;

		.engineeringName {
			font-size: 26px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #333;
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 130px;
			justify-content: center;

			.line {
				width: 55px;
				height: 2px;
				background: #c2c2c2;
				margin-top: 10px;
			}
		}
	}

	.engineeringMain-wrapper {
		display: flex;
		flex-direction: column;
		.title {
			width: 1300px;
			margin: 0 auto;
			font-size: 20px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #333;
			// height: 130px;
			margin-bottom: 20px;
		}
		.engineeringMain {
			display: flex;
			flex-wrap: wrap;
			width: 1300px;
			margin: 0 auto;

			a {
				color: #004ea1;
				text-decoration: none;
				text-align: center;
			}

			// justify-content: space-between;

			.engineeringMainItem {
				font-size: 20px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #004ea1;
				display: flex;
				flex-wrap: wrap;
				flex-direction: column;
				align-items: center;
				margin-bottom: 50px;
				margin-right: 10px;
				overflow: hidden;

				img {
					width: 310px;
					height: 225px;
					margin-bottom: 20px;
					object-fit: fill;
					cursor: pointer;
					transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
				}
			}

			.engineeringMainItem:hover {
				img {
					transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
					transform: scale(1.1);
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue